













import { View } from 'client-website-ts-library/plugins';
import { API, Config } from 'client-website-ts-library/services';
import { Context, Listing, Office } from 'client-website-ts-library/types';
import { ContextItemType } from 'client-website-ts-library/types/Context';
import { Component, Mixins } from 'vue-property-decorator';

import Form from '../components/Forms/Form.vue';

@Component({
  components: {
    Form,
  },
})

export default class TownsvilleTenancyApplicationForm extends Mixins(View) {
  private formCtx: Context | null = null

  private office: Office | null = null

  private listing: Listing | null = null;

  mounted() {
    API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
      this.office = office;
    });

    const ctx: Context = {
      ClientWebsiteId: Config.Website.Id,
      Items: [
        {
          Type: ContextItemType.EnquiryTargetProfile,
          Id: Config.Website.Settings!.WebsiteId,
        },
      ],
    };

    const listingId = this.$route.query.listingId ?? undefined;

    if (listingId) {
      API.Listings.Get(listingId.toString()).then((listing) => {
        this.listing = listing;
      });

      ctx.Items.push({
        Type: ContextItemType.Listing,
        Id: listingId as string,
      });
    }

    this.formCtx = ctx;
  }
}
